const INITIAL_STATE = {
  data: {},
  errors: {},
          
}
const StripeLogin = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'LOGIN_STRIPE_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'LOGIN_STRIPE_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
          
export default StripeLogin;